import React from "react";
import DocumentService from "../../services/DocumentStore/DocumentService";

const {
  getSupportedContentTypes,
  getSupportedFileExtensions,
} = DocumentService;

const ProfileFeedbackUpload = ({
  onFileSelectError,
  onFileSelectSuccess,
  maxFileSize = 700000,
}) => {
  const successfulFiles = [];

  let supportedTypes;
  getSupportedContentTypes().then(
    (res) => (supportedTypes = JSON.stringify(res))
  );

  let supportedExtensions;
  getSupportedFileExtensions().then(
    (res) => (supportedExtensions = JSON.stringify(res))
  );

  const handleFileInput = (e) => {
    const files = e.target.files;

    Object.keys(files).forEach((key) => {
      let file = files[key];

      let fileExtension = file.name.slice(
        ((file.name.lastIndexOf(".") - 1) >>> 0) + 2
      );

      let supportedFileType = supportedTypes.indexOf(file.type) > 0;
      let supportedFileExtension =
        supportedExtensions.indexOf(fileExtension) > 0;

      if (!supportedFileType || !supportedFileExtension) {
        onFileSelectError({ error: "Upload Error - Unsupported file type!" });
        return;
      }

      if (file.size > maxFileSize) {
        onFileSelectError({
          error:
            "File is too large, maximum accepted size is " +
            maxFileSize / 1000 +
            "KB",
        });
        return;
      }
      successfulFiles.push(file);
    });

    onFileSelectSuccess(successfulFiles);
  };

  return (
    <div className="file-uploader">
      Attach
      <input
        type="file"
        className="hide-file"
        multiple
        onChange={handleFileInput}
      />
    </div>
  );
};

export default ProfileFeedbackUpload;
